import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import BespokeHero from "./components/BespokeHero";
import OverviewSection from "./components/OverviewSection";
import WhatWeDo from "./components/WhatWeDo";
import ApproachSection from "./components/ApproachSection";
import WhyBespoke from "./components/WhyBespoke";
import UseCases from "./components/UseCases";
import BespokeCTA from "./components/BespokeCTA";
import { usePageMeta } from "../../hooks/usePageMeta";

export default function BespokePage() {
  usePageMeta(
    "Bespoke Development | StackMap Systems",
    "Custom software development services from StackMap. Tailored operational systems built for your exact business requirements."
  );

  return (
    <div className="min-h-screen bg-graphite-900">
      <Navbar />
      <main>
        <BespokeHero />
        <OverviewSection />
        <WhatWeDo />
        <ApproachSection />
        <WhyBespoke />
        <UseCases />
        <BespokeCTA />
      </main>
      <Footer />
    </div>
  );
}
